import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MainLayoutComponent } from './modules/material-layout/components/main-layout/main-layout.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [MainLayoutComponent]
})
export class AppComponent {
  title = 'front-cd77-socle';

  constructor() {
    console.log('# env : ' + environment.env_name);
  }
}
